import React from 'react'
import { styled, Typography, TypographyProps } from '@mui/material'

type PageNameProps = Omit<TypographyProps, 'children'> & {
  children: string;
}

const PageName = styled((props: PageNameProps) => (
  <>
    <title>{props.children}</title>
    <Typography {...props} variant='h1' />
  </>
))(({ theme: { spacing, breakpoints }}) => ({
  fontWeight: 300,
  lineHeight: 'normal',
  paddingLeft: spacing(1),
  fontSize: 20,
  [breakpoints.up('sm')]: {
    fontSize: 25,
  }
}))

export default PageName